import React from "react";
import PropTypes from "prop-types";
import { Collapse, Typography, Divider } from "antd";
import RenderFields  from "./RenderFields";
import {
  constraints1, constraints2, constraints3,
  w_filters_1, w_filters_2, w_filters_3, w_filters_4, w_filters_5, w_filters_6,
  w_filters_7, w_filters_8, w_filters_9, w_filters_10, w_filters_11
} from "../../constants/attributeDetails"; 

const { Panel } = Collapse;
const { Title, Text } = Typography;

export default function MandatoryParameters ({ // Renamed
  formData,
  molecularScaffold, 
  learningRelated,  
  displayField,
  handleInputChange,
  handleSlider,
  handleSigmoidValue,
  setFormData, 
  projectId, // Assuming this is passed down for some reason
  isReTriggerMode,
}) {

  const constraintsList = [
    constraints1, constraints2, constraints3,  w_filters_1, w_filters_2, w_filters_3, 
    w_filters_4, w_filters_5, w_filters_6, w_filters_7, w_filters_8, 
    w_filters_9, w_filters_10, w_filters_11,
  ];

  // Custom panel header style for AntD Collapse
  const panelHeaderStyle = {
    backgroundColor: "#003A6C", // Original MUI color
    // color: "white", // Text color set on Text component
    fontWeight: "bold",
    borderRadius: "4px", // Match AntD default panel border radius for consistency
  };
  
  const collapseStyle = {
    backgroundColor: "transparent",
    border: "none",
    marginBottom: "12px" // Original MUI margin
  };

  return (
    <Collapse 
        defaultActiveKey={["1"]} // Keep it expanded by default
        style={collapseStyle}
        bordered={false}
        expandIconPosition="end"
    >
      <Panel 
        header={<Text style={{color: "white", fontWeight: "bold"}}>Mandatory Parameters</Text>} 
        key="1" 
        style={panelHeaderStyle}
        // To remove default padding from Panel content if children handle it:
        // styles={{ content: { padding: 0 } }} 
      >
        {/* Content previously in AccordionDetails */}
        <div style={{ padding: "16px", background: "#fff", marginLeft: 0, color: "#000", borderRadius: "0 0 4px 4px" }}>
          <Title level={5} style={{ marginLeft: 0, marginTop: 0, marginBottom: 8 }}> 
           Chemical Space
          </Title>
          <RenderFields  // Calling the AntD version of renderFields
            fields={molecularScaffold}
            formData={formData}
            displayField={displayField}
            handleInputChange={handleInputChange}
            handleSlider={handleSlider}
            handleSigmoidValue={handleSigmoidValue}
            setFormData={setFormData} 
            projectId={projectId} // Assuming this is needed for some fields
            isReTriggerMode={isReTriggerMode}
          />

          <Divider style={{margin: "16px 0"}}/>

          <Title level={5} style={{ marginLeft: 0, marginTop: 16, marginBottom: 8 }}>
            Learning Related
          </Title>
          <RenderFields 
            projectId={projectId}
            fields={learningRelated}
            formData={formData}
            displayField={displayField}
            handleInputChange={handleInputChange}
            handleSlider={handleSlider}
            handleSigmoidValue={handleSigmoidValue}
            isReTriggerMode={isReTriggerMode}
            // setFormData // Not passed in original for this section
          />

          <Divider style={{margin: "16px 0"}}/>

          <Title level={5} style={{  marginTop: 16, marginBottom: 8 }}>
            Constraints
          </Title>
         {constraintsList?.map((item, index) => (
          <div
            key={index}
            style={{
              // ensure the group always takes up space even if empty
              minHeight: "56px",
              // vertical padding for breathing room
              // padding: '16px 0',
              // separate groups visually
              marginBottom: 16,
              borderBottom:
                index < constraintsList.length - 1
                  ? "1px solid #f0f0f0"
                  : "none",
            }}
          >
            <RenderFields
              fields={item}
              projectId={projectId}
              formData={formData}
              displayField={displayField}
              handleInputChange={handleInputChange}
              handleSlider={handleSlider}
              handleSigmoidValue={handleSigmoidValue}
              isReTriggerMode={isReTriggerMode}
            />
          </div>
        ))}

        </div>
      </Panel>
    </Collapse>
  );
}

MandatoryParameters.propTypes = {
  formData: PropTypes.object.isRequired,
  molecularScaffold: PropTypes.array.isRequired,
  learningRelated: PropTypes.array.isRequired,
  displayField: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSlider: PropTypes.func.isRequired,
  handleSigmoidValue: PropTypes.func.isRequired,
  setFormData: PropTypes.func.isRequired, 
  isReTriggerMode: PropTypes.bool,
};
